module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10rQO8F/tc-custom/9780358381228.jpg?1718183455079",
      "alt": "This image is the cover for the book Best American Essays 2021, The Best American Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best American Essays 2021, The Best American Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A collection of the year’s best essays, selected by award-winning journalist and "), _c('i', [_vm._v("New Yorker ")]), _vm._v("staff writer Kathryn Schulz")])]), _c('p', [_vm._v("“The world is abundant even in bad times,” guest editor Kathryn Schulz writes in her introduction, “it is lush with interestingness, and always, somewhere, offering up consolation or beauty or humor or happiness, or at least the hope of future happiness.” The essays Schulz selected are a powerful time capsule of 2020, showcasing that even if our lives as we knew them stopped, the beauty to be found in them flourished. From an intimate account of nursing a loved one in the early days of the pandemic, to a masterful portrait of grieving the loss of a husband as the country grieved the loss of George Floyd, this collection brilliantly shapes the grief, hardship, and hope of a singular year.")]), _c('p', [_c('b', [_vm._v("The Best American Essays 2021 includes"), _c('br'), _vm._v(" ELIZABETH ALEXANDER • HILTON ALS • GABRIELLE HAMILTON • RUCHIR JOSHI • PATRICIA LOCKWOOD• CLAIRE MESSUD • WESLEY MORRIS • BETH NGUYEN • JESMYN WARD and others")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathryn Schulz, Robert Atwan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0